import * as React from "react";
import { Paragraph } from "@arctheme-components/elements/Paragraph/Paragraph";
import { Collapsible } from "@src/stories/elements/Collapsible/Collapsible";
import { Link } from "@arctheme-components/elements/Link/Link";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

export const FooterLinks = ({ id, globals, shop, settings, list_links, type }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);

  const list_settings = list_links.settings;

  return (
    <div key={id} className={`footer-links-list`}>
      <Collapsible
        title={isMobile ? list_links.links_title : ""}
        titleClass={`${isMobile ? list_settings.link_style_mobile : list_settings.link_style}`}
        contentClass={`${isMobile ? list_settings.link_style_mobile : list_settings.link_style}`}
        openIcon="icon-arrow-right"
        closeIcon="icon-arrow-right"
        rotateIcon={true}
        desktopDisabled
        mobileDisabled
      >
        <nav className="footer-nav" aria-label="Footer Menu">
          <ul aria-label="footer menu" role="menu">
            {list_links.links.map((link, id) => {
              return (
                <li key={id} role="menuitem">
                  <Link link={link.url} openInNewTab={list_links?.settings?.open_links_new_tab || false}>
                      {link.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </Collapsible>
    </div>
  );
};
